import { Id } from '@nextforce/api'
import { NonAvailabilityQueryParams } from '../types'

const keys = {
  all: ['non_availability'],
  detail: (params: NonAvailabilityQueryParams) => [...keys.all, params],
  list: (storeId: Id) => [...keys.all, storeId],
}

export default keys
